//引入Vue
import Vue from "vue"; 
//引入vue-router
import Router from "vue-router"; 
//引入routes.js
import routers from "./routes";

//Vue全局使用Router
Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes:routers
  // routes    //routes: routes的缩写
  // linkActiveClass: "linkActive"
});
